import * as actions from './course-player.actions';
import { EntityState, createEntityAdapter, Dictionary } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';


export interface UI {
  content: { 
    zoom: number,
    pageId: number,
    pageUrl: string,
    pageAudioIndex: number,
    currentAudioIndex: number,
    completed: number,
    tipsIcon: boolean,
    showingTips: boolean,
    tipsContent: string
  },
  leftNavButton: {
    visible: boolean,
    disabled: boolean,
    isPrevUnit: boolean,
    isPrevModule: boolean,
    prevUnitId: number,
    prevModuleId: number
  },
  rightNavButton: {
    visible: boolean,
    disabled: boolean,
    isNextUnit: boolean,
    isNextModule: boolean,
    nextUnitId: number,
    nextModuleId: number
  },
  audioPanel: {
    visible: boolean,
    hasAudio: boolean,
    audioStartTime: number,
    audioCompleted: number,
    showAudioScrub: boolean,
    leftSkipButton: {
      visible: boolean,
      disabled: boolean
    },
    rightSkipButton: {
      visible: boolean,
      disabled: boolean
    },
    playPauseButton: {
        visible: boolean,
        disabled: boolean
    }
  }
}

export interface Page { 
    id: number,
    content: string,
    pageUrl: string,    
    audioIndex: number,
    isStart: boolean,
    isEnd: boolean,
    nextModule: boolean,
    nextModuleId: number,
    nextUnit: boolean,
    nextUnitId: number,
    prevModule: boolean,
    prevModuleId: number,
    prevUnit: boolean,
    prevUnitId: number,
    unitId: number,
    moduleId: number,
    audioCount: number
}

export interface State extends EntityState<Page> {
  selectedId: number,
  courseId: string,
  ui: UI
};

export const coursePlayerAdapter = createEntityAdapter<Page> ();

const defaultCoursePlayer = {  
  selectedId: 0,
  courseId: "",
  ui: {
    content: {
      zoom: 100,
      pageId: 0,
      pageUrl: "https://fsi-application.s3.amazonaws.com/latin-spanish/spanish-latin-america-loading.jpg",
      pageAudioIndex: 0,
      currentAudioIndex: 0,
      completed: 0,
      tipsIcon: false,
      showingTips: false,
      tipsContent: ""
    },
    leftNavButton: {
      visible: false,
      disabled: true,
      isPrevUnit: false,
      isPrevModule: false,
      prevUnitId: 0,
      prevModuleId: 0
    },
    rightNavButton: {
      visible: true,
      disabled: true,              
      isNextUnit: false,
      isNextModule: false,
      nextUnitId: 0,
      nextModuleId: 0
    },
    audioPanel: {    
      visible: false,
      hasAudio: false,      
      audioStartTime: -1,
      audioCompleted: 0,
      showAudioScrub: false,
      leftSkipButton: {
        visible: true,
        disabled: true
      },
      rightSkipButton: {
        visible: true,
        disabled: true
      },
      playPauseButton: {
          visible: true,
          disabled: true
      }
    } 
  }
}

export const initialState: State = coursePlayerAdapter.getInitialState(defaultCoursePlayer);

export function coursePlayerReducer(
  state: State = initialState, 
  action: actions.PageActions): State {
  switch (action.type) {      
    
    case actions.SKIP_BACK:      
      return state;

      case actions.AUDIO_SCRUB_INTERVAL:
        return state;
      case actions.AUDIO_SCRUB_UPDATE:
        
        var pageEntity = state.entities[state.selectedId];
        var audioSeek:number = action.audioSeek
        
        let percentage = 100 - (100 / pageEntity.audioCount) 
        * ((pageEntity.audioIndex + pageEntity.audioCount) 
        - (<any>audioSeek).audioSeek);             

        return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
          { ...state, 
            selectedId: state.selectedId, 
            courseId: state.courseId,
            ui: { 
              content: { 
                zoom: state.ui.content.zoom,
                pageId: state.ui.content.pageId, 
                pageUrl: state.ui.content.pageUrl,
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: state.ui.content.completed,
                tipsIcon: state.ui.content.tipsIcon,
                showingTips: state.ui.content.showingTips,
                tipsContent: state.ui.content.tipsContent
              },
              leftNavButton: { 
                disabled: state.ui.leftNavButton.disabled, 
                visible: state.ui.leftNavButton.visible,
                isPrevUnit: state.ui.leftNavButton.isPrevUnit,
                isPrevModule: state.ui.leftNavButton.isPrevModule,
                prevUnitId: state.ui.leftNavButton.prevUnitId,
                prevModuleId: state.ui.leftNavButton.prevModuleId 
              },
              rightNavButton: { 
                disabled: state.ui.rightNavButton.disabled, 
                visible: state.ui.rightNavButton.visible,              
                isNextUnit: state.ui.rightNavButton.isNextUnit,
                isNextModule: state.ui.rightNavButton.isNextModule,
                nextUnitId: state.ui.rightNavButton.nextUnitId,
                nextModuleId: state.ui.rightNavButton.nextModuleId
              },
              audioPanel: {    
                visible: state.ui.audioPanel.visible,
                hasAudio: state.ui.audioPanel.hasAudio,
                audioStartTime: state.ui.audioPanel.audioStartTime,
                audioCompleted: percentage,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: state.ui.audioPanel.leftSkipButton.visible,
                  disabled: state.ui.audioPanel.leftSkipButton.disabled
                },
                rightSkipButton: {
                  visible: state.ui.audioPanel.rightSkipButton.visible,
                  disabled: state.ui.audioPanel.rightSkipButton.disabled
                },
                playPauseButton: {
                    visible: state.ui.audioPanel.playPauseButton.visible,
                    disabled: state.ui.audioPanel.playPauseButton.disabled
                }
              } 
            }
          });    

      case actions.LOAD_PROGRESS:

        // pre-loaded state
        return action.state;

      case actions.ZOOM:

      let zoom = 100;

      if (state.ui.content.zoom == 100) {
        zoom = state.ui.content.zoom + 50
      } else if (state.ui.content.zoom == 150) {
        zoom = state.ui.content.zoom + 50
      } else if (state.ui.content.zoom == 200) {
        zoom = 100;
      }

      console.log("ZOOM", { zoom: zoom });

        return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
          { ...state, 
            selectedId: state.selectedId, 
            courseId: state.courseId,
            ui: { 
              content: { 
                zoom: zoom,
                pageId: state.ui.content.pageId, 
                pageUrl: state.ui.content.pageUrl,
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: state.ui.content.completed,
                tipsIcon: state.ui.content.tipsIcon,
                showingTips: state.ui.content.showingTips,
                tipsContent: state.ui.content.tipsContent
              },
              leftNavButton: { 
                disabled: state.ui.leftNavButton.disabled, 
                visible: state.ui.leftNavButton.visible,
                isPrevUnit: state.ui.leftNavButton.isPrevUnit,
                isPrevModule: state.ui.leftNavButton.isPrevModule,
                prevUnitId: state.ui.leftNavButton.prevUnitId,
                prevModuleId: state.ui.leftNavButton.prevModuleId  
              },
              rightNavButton: { 
                disabled: state.ui.rightNavButton.disabled, 
                visible: state.ui.rightNavButton.visible,              
                isNextUnit: state.ui.rightNavButton.isNextUnit,
                isNextModule: state.ui.rightNavButton.isNextModule,
                nextUnitId: state.ui.rightNavButton.nextUnitId,
                nextModuleId: state.ui.rightNavButton.nextModuleId
              },
              audioPanel: {    
                visible: state.ui.audioPanel.visible,
                hasAudio: state.ui.audioPanel.hasAudio,
                audioStartTime: state.ui.audioPanel.audioStartTime,
                audioCompleted: state.ui.audioPanel.audioCompleted,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: state.ui.audioPanel.leftSkipButton.visible,
                  disabled: state.ui.audioPanel.leftSkipButton.disabled
                },
                rightSkipButton: {
                  visible: state.ui.audioPanel.rightSkipButton.visible,
                  disabled: state.ui.audioPanel.rightSkipButton.disabled
                },
                playPauseButton: {
                    visible: state.ui.audioPanel.playPauseButton.visible,
                    disabled: state.ui.audioPanel.playPauseButton.disabled
                }
              } 
            }
          });    

      case actions.CLOSE:
      
      return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
        { ...state, 
          selectedId: state.selectedId, 
          courseId: state.courseId,
          ui: { 
            content: { 
              zoom: state.ui.content.zoom,
              pageId: state.ui.content.pageId, 
              pageUrl: state.ui.content.pageUrl,
              pageAudioIndex: state.ui.content.pageAudioIndex,
              currentAudioIndex: state.ui.content.currentAudioIndex,
              completed: state.ui.content.completed,
              tipsIcon: state.ui.content.tipsIcon,
              showingTips: false,
              tipsContent: state.ui.content.tipsContent
            },
            leftNavButton: { 
              disabled: state.ui.leftNavButton.disabled, 
              visible: state.ui.leftNavButton.visible,
              isPrevUnit: state.ui.leftNavButton.isPrevUnit,
              isPrevModule: state.ui.leftNavButton.isPrevModule,
              prevUnitId: state.ui.leftNavButton.prevUnitId,
              prevModuleId: state.ui.leftNavButton.prevModuleId 
            },
            rightNavButton: { 
              disabled: state.ui.rightNavButton.disabled, 
              visible: state.ui.rightNavButton.visible,              
              isNextUnit: state.ui.rightNavButton.isNextUnit,
              isNextModule: state.ui.rightNavButton.isNextModule,
              nextUnitId: state.ui.rightNavButton.nextUnitId,
              nextModuleId: state.ui.rightNavButton.nextModuleId
            },
            audioPanel: {    
              visible: state.ui.audioPanel.visible,
              hasAudio: state.ui.audioPanel.hasAudio,
              audioStartTime: state.ui.audioPanel.audioStartTime,
              audioCompleted: state.ui.audioPanel.audioCompleted,
              showAudioScrub: state.ui.audioPanel.showAudioScrub,
              leftSkipButton: {
                visible: state.ui.audioPanel.leftSkipButton.visible,
                disabled: state.ui.audioPanel.leftSkipButton.disabled
              },
              rightSkipButton: {
                visible: state.ui.audioPanel.rightSkipButton.visible,
                disabled: state.ui.audioPanel.rightSkipButton.disabled
              },
              playPauseButton: {
                  visible: true, // turns off the play button
                  disabled: state.ui.audioPanel.playPauseButton.disabled
              }
            } 
          }
        });  
        
      case actions.SHOW_TIPS:

        return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
          { ...state, 
            selectedId: state.selectedId, 
            courseId: state.courseId,
            ui: { 
              content: { 
                zoom: state.ui.content.zoom,
                pageId: state.ui.content.pageId, 
                pageUrl: state.ui.content.pageUrl,
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: state.ui.content.completed,
                tipsIcon: state.ui.content.tipsIcon,
                showingTips: !state.ui.content.showingTips,
                tipsContent: state.ui.content.tipsContent
              },
              leftNavButton: { 
                disabled: state.ui.leftNavButton.disabled, 
                visible: state.ui.leftNavButton.visible,
                isPrevUnit: state.ui.leftNavButton.isPrevUnit,
                isPrevModule: state.ui.leftNavButton.isPrevModule,
                prevUnitId: state.ui.leftNavButton.prevUnitId,
                prevModuleId: state.ui.leftNavButton.prevModuleId 
              },
              rightNavButton: { 
                disabled: state.ui.rightNavButton.disabled, 
                visible: state.ui.rightNavButton.visible,              
                isNextUnit: state.ui.rightNavButton.isNextUnit,
                isNextModule: state.ui.rightNavButton.isNextModule,
                nextUnitId: state.ui.rightNavButton.nextUnitId,
                nextModuleId: state.ui.rightNavButton.nextModuleId
              },
              audioPanel: {    
                visible: state.ui.audioPanel.visible,
                hasAudio: state.ui.audioPanel.hasAudio,
                audioStartTime: state.ui.audioPanel.audioStartTime,
                audioCompleted: state.ui.audioPanel.audioCompleted,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: state.ui.audioPanel.leftSkipButton.visible,
                  disabled: state.ui.audioPanel.leftSkipButton.disabled
                },
                rightSkipButton: {
                  visible: state.ui.audioPanel.rightSkipButton.visible,
                  disabled: state.ui.audioPanel.rightSkipButton.disabled
                },
                playPauseButton: {
                    visible: state.ui.audioPanel.playPauseButton.visible,
                    disabled: state.ui.audioPanel.playPauseButton.disabled
                }
              } 
            }
          });      

      case actions.PLAY:
                 
        return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
        { ...state, 
          selectedId: state.selectedId, 
          courseId: state.courseId,
          ui: { 
            content: { 
              zoom: state.ui.content.zoom,
              pageId: state.ui.content.pageId, 
              pageUrl: state.ui.content.pageUrl,
              pageAudioIndex: state.ui.content.pageAudioIndex,
              currentAudioIndex: state.ui.content.currentAudioIndex,
              completed: state.ui.content.completed,
              tipsIcon: state.ui.content.tipsIcon,
              showingTips: state.ui.content.showingTips,
              tipsContent: state.ui.content.tipsContent
            },
            leftNavButton: { 
              disabled: state.ui.leftNavButton.disabled, 
              visible: state.ui.leftNavButton.visible,
              isPrevUnit: state.ui.leftNavButton.isPrevUnit,
              isPrevModule: state.ui.leftNavButton.isPrevModule,
              prevUnitId: state.ui.leftNavButton.prevUnitId,
              prevModuleId: state.ui.leftNavButton.prevModuleId 
            },
            rightNavButton: { 
              disabled: state.ui.rightNavButton.disabled, 
              visible: state.ui.rightNavButton.visible,              
              isNextUnit: state.ui.rightNavButton.isNextUnit,
              isNextModule: state.ui.rightNavButton.isNextModule,
              nextUnitId: state.ui.rightNavButton.nextUnitId,
              nextModuleId: state.ui.rightNavButton.nextModuleId
            },
            audioPanel: {    
              visible: state.ui.audioPanel.visible,
              hasAudio: state.ui.audioPanel.hasAudio,
              audioStartTime: state.ui.audioPanel.audioStartTime,
              audioCompleted: state.ui.audioPanel.audioCompleted,
              showAudioScrub: state.ui.audioPanel.showAudioScrub,
              leftSkipButton: {
                visible: state.ui.audioPanel.leftSkipButton.visible,
                disabled: state.ui.audioPanel.leftSkipButton.disabled
              },
              rightSkipButton: {
                visible: state.ui.audioPanel.rightSkipButton.visible,
                disabled: state.ui.audioPanel.rightSkipButton.disabled
              },
              playPauseButton: {
                  visible: false,
                  disabled: state.ui.audioPanel.playPauseButton.disabled
              }
            } 
          }
        });

        case actions.PAUSE:                
          
          return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
          { ...state, 
            selectedId: state.selectedId, 
            courseId: state.courseId,
            ui: { 
              content: { 
                zoom: state.ui.content.zoom,
                pageId: state.ui.content.pageId, 
                pageUrl: state.ui.content.pageUrl,
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: state.ui.content.completed,
                tipsIcon: state.ui.content.tipsIcon,
                showingTips: state.ui.content.showingTips,
                tipsContent: state.ui.content.tipsContent
              },
              leftNavButton: { 
                disabled: state.ui.leftNavButton.disabled, 
                visible: state.ui.leftNavButton.visible,
                isPrevUnit: state.ui.leftNavButton.isPrevUnit,
                isPrevModule: state.ui.leftNavButton.isPrevModule,
                prevUnitId: state.ui.leftNavButton.prevUnitId,
                prevModuleId: state.ui.leftNavButton.prevModuleId 
              },
              rightNavButton: { 
                disabled: state.ui.rightNavButton.disabled, 
                visible: state.ui.rightNavButton.visible,              
                isNextUnit: state.ui.rightNavButton.isNextUnit,
                isNextModule: state.ui.rightNavButton.isNextModule,
                nextUnitId: state.ui.rightNavButton.nextUnitId,
                nextModuleId: state.ui.rightNavButton.nextModuleId
              },
              audioPanel: {    
                visible: state.ui.audioPanel.visible,
                hasAudio: state.ui.audioPanel.hasAudio,
                audioStartTime: state.ui.audioPanel.audioStartTime,
                audioCompleted: state.ui.audioPanel.audioCompleted,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: state.ui.audioPanel.leftSkipButton.visible,
                  disabled: state.ui.audioPanel.leftSkipButton.disabled
                },
                rightSkipButton: {
                  visible: state.ui.audioPanel.rightSkipButton.visible,
                  disabled: state.ui.audioPanel.rightSkipButton.disabled
                },
                playPauseButton: {
                    visible: true,
                    disabled: state.ui.audioPanel.playPauseButton.disabled
                }
              }  
            }
          });

      case actions.PAGE_LEFT:
      
        // Is this the first page?
        // Does this new page have audio?               
        var selectedId = state.selectedId - 1
        var page = state.entities[selectedId]

        var index = (state.ids as number[]).indexOf(selectedId);
        var indexLength = state.ids.length-1;        
        var audioIndex = page.audioIndex;
        var completed = (100 / indexLength) * index;
        
        var audioIndex = page.audioIndex;
        var isFirstPage = false;
        
        if (index == 0) {          
          isFirstPage = true;
        }

        var leftButtonDisabled = page.isStart;
        var rightButtonDisabled = page.isEnd;
        
        return coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
          { ...state, 
            selectedId: selectedId, 
            courseId: state.courseId,
            ui: { 
              content: { 
                zoom: state.ui.content.zoom,
                pageId: page.id, 
                pageUrl: page.pageUrl,
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: completed,
                tipsIcon: state.ui.content.tipsContent.length > 0,
                showingTips: false,
                tipsContent: state.ui.content.tipsContent 
              },
              leftNavButton: { 
                disabled: leftButtonDisabled, 
                visible: true,
                isPrevUnit: page.prevUnit,
                isPrevModule: page.prevModule,
                prevUnitId: isFirstPage && page.prevUnit ? page.prevUnitId : -1,
                prevModuleId: isFirstPage && page.prevModule ? page.prevModuleId: -1
              },
              rightNavButton: { 
                disabled: rightButtonDisabled, 
                visible: true,              
                isNextUnit: false,
                isNextModule: false,
                nextUnitId: -1,
                nextModuleId: -1
              },
              audioPanel: {    
                visible: audioIndex > -1,
                hasAudio: audioIndex > -1,
                audioStartTime: page.audioIndex,
                audioCompleted: 0,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: true,
                  disabled: audioIndex < 0
                },
                rightSkipButton: {
                  visible: true,
                  disabled: audioIndex < 0
                },
                playPauseButton: {
                    visible: true,
                    disabled: audioIndex < 0
                }
              }  
            }
          });
    
      case actions.PAGE_RIGHT:
              
        var isLastPage = false;
        var selectedId: number = state.selectedId + 1
        var page = state.entities[selectedId]
        
        var lastPageId = state.ids[state.ids.length-1]

        var lastPage = state.entities[lastPageId];                
        if (selectedId == lastPage.id) {
          isLastPage = true;          
          // TODO: only if last page in the entire course
          //rightButtonDisabled = true          
        }

        var index = (state.ids as number[]).indexOf(selectedId);
        var indexLength = state.ids.length - 1;        
        var audioIndex = page.audioIndex;
        var completed = (100 / indexLength) * index;
      
        var leftButtonDisabled = page.isStart;
        var rightButtonDisabled = page.isEnd;
      
      let thisState = coursePlayerAdapter.updateOne({ id: 0, changes: {} }, 
        { ...state, 
          selectedId: selectedId, 
          courseId: state.courseId,
          ui: { 
            content: {
              zoom: state.ui.content.zoom,
              pageId: page.id, 
              pageUrl: page.pageUrl,
              pageAudioIndex: state.ui.content.pageAudioIndex,
              currentAudioIndex: state.ui.content.currentAudioIndex,
              completed: completed,
              tipsIcon: state.ui.content.tipsContent.length > 0,
              showingTips: false,
              tipsContent: state.ui.content.tipsContent 
            },
            leftNavButton: { 
              disabled: leftButtonDisabled, 
              visible: true,
              isPrevUnit: false,
              isPrevModule: false,
              prevUnitId: -1,
              prevModuleId: -1
            },
            rightNavButton: { 
              disabled: rightButtonDisabled, 
              visible: true,              
              isNextUnit: page.nextUnit,
              isNextModule: page.nextModule,
              nextUnitId: isLastPage && page.nextUnit ? page.nextUnitId : -1,
              nextModuleId: isLastPage && page.nextModule ? page.nextModuleId: -1
            },
            audioPanel: {    
              visible: audioIndex > -1,
              hasAudio: audioIndex > -1,
              audioStartTime: audioIndex,
              audioCompleted: 0,
              showAudioScrub: state.ui.audioPanel.showAudioScrub,
              leftSkipButton: {
                visible: true,
                disabled: audioIndex < 0
              },
              rightSkipButton: {
                visible: true,
                disabled: audioIndex < 0
              },
              playPauseButton: {
                  visible: true,
                  disabled: audioIndex < 0
              }
            }  
          }
        });

        return thisState;
  
      case actions.LOAD:
        
        var page = action.loadLastPage ? action.pages[action.pages.length-1] : action.pages[0];
        
        var audioIndex = page.audioIndex;                
        
        var index = (action.pages.map(o => o.id) as number[]).indexOf(page.id);
        index++;
        var completed = action.loadLastPage ? (100 / action.pages.length) * index : 0;        

        console.log("completed", {
          completed: completed,
          indexLength: action.pages.length,
          index: index,          
          ids: state.ids,
          page: page,
          pages: action.pages
        })

        let newState = coursePlayerAdapter.removeAll(state);

        var leftButtonDisabled = page.isStart;
        var rightButtonDisabled = page.isEnd;

        return coursePlayerAdapter.addMany(action.pages, 
          { ...newState, 
            selectedId: page.id, 
            courseId: action.courseId,
            ui: { 
              content: { 
                zoom: state.ui.content.zoom,
                pageId: page.id, 
                pageUrl: "",
                pageAudioIndex: state.ui.content.pageAudioIndex,
                currentAudioIndex: state.ui.content.currentAudioIndex,
                completed: completed,
                tipsIcon: state.ui.content.tipsIcon,
                showingTips: false,
                tipsContent: state.ui.content.tipsContent
              },
              leftNavButton: { 
                disabled: leftButtonDisabled, 
                visible: true,
                isPrevUnit: page.prevUnit,
                isPrevModule: page.prevModule,
                prevUnitId: page.prevUnitId,
                prevModuleId: page.prevModuleId 
              },
              rightNavButton: { 
                disabled: rightButtonDisabled, 
                visible: true,              
                isNextUnit: page.nextUnit,
                isNextModule: page.nextModule,
                nextUnitId: page.nextUnitId,
                nextModuleId: page.nextModuleId
              },
              audioPanel: {    
                visible: page.audioIndex > -1,
                hasAudio: page.audioIndex > -1,
                audioStartTime: audioIndex,
                audioCompleted: 0,
                showAudioScrub: state.ui.audioPanel.showAudioScrub,
                leftSkipButton: {
                  visible: true,
                  disabled: audioIndex < 0
                },
                rightSkipButton: {
                  visible: true,
                  disabled: audioIndex < 0
                },
                playPauseButton: {
                  visible: true,
                  disabled: audioIndex < 0
                }
              }  
            }
          });
        

      default: 
          return state;
  }
}

export const getCoursePlayerState = createFeatureSelector<State>('coursePlayer');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = coursePlayerAdapter.getSelectors(getCoursePlayerState);